import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";
import { Package, ShoppingCart, Euro, AlertTriangle, Clock, CheckCircle2 } from "lucide-react";

export default function AdminDashboard() {
    const [s, setS] = useState(null);
    const [orders, setOrders] = useState([]);
    useEffect(() => {
        api.get("/admin/stats").then((r) => setS(r.data));
        api.get("/admin/orders?limit=5").then((r) => setOrders(r.data));
    }, []);

    const cards = s
        ? [
              { icon: Package, t: "Produtos activos", v: s.total_products, c: "bg-paper" },
              { icon: ShoppingCart, t: "Encomendas", v: s.total_orders, c: "bg-paper" },
              { icon: CheckCircle2, t: "Pagas", v: s.paid_orders, c: "bg-paper" },
              { icon: Clock, t: "Pendentes", v: s.pending_orders, c: "bg-paper" },
              { icon: AlertTriangle, t: "Sem stock", v: s.out_of_stock, c: "bg-paper" },
              { icon: Euro, t: "Receita (paga)", v: fmtEUR(s.revenue), c: "bg-magenta text-white" },
          ]
        : [];

    return (
        <div data-testid="admin-dashboard">
            <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Dashboard</h1>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-0 border-2 border-ink">
                {cards.map(({ icon: Icon, t, v, c }, i) => (
                    <div
                        key={t}
                        className={`p-6 ${c} ${i % 3 !== 2 ? "lg:border-r-2 border-ink" : ""} ${
                            i < cards.length - 3 ? "lg:border-b-2 border-ink" : ""
                        } ${i % 2 === 0 ? "sm:border-r-2 lg:border-r-2 border-ink" : ""}`}
                    >
                        <Icon size={20} className={c.includes("magenta") ? "text-white" : "text-magenta"} />
                        <div className={`label-mono mt-3 ${c.includes("magenta") ? "text-white/70" : ""}`}>{t}</div>
                        <div className="font-display font-black text-3xl mt-1">{v}</div>
                    </div>
                ))}
            </div>

            <h2 className="font-display font-black text-2xl mt-12 mb-4">Últimas encomendas</h2>
            <div className="border-2 border-ink bg-white overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-ink text-white text-xs font-mono uppercase tracking-wider">
                        <tr>
                            <th className="text-left p-3">Nº</th>
                            <th className="text-left p-3">Cliente</th>
                            <th className="text-left p-3">Método</th>
                            <th className="text-left p-3">Estado</th>
                            <th className="text-right p-3">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((o) => (
                            <tr key={o.id} className="border-t-2 border-ink/10">
                                <td className="p-3 font-mono">{o.order_number}</td>
                                <td className="p-3">{o.customer.name}</td>
                                <td className="p-3 font-mono uppercase">{o.payment_method}</td>
                                <td className="p-3">
                                    <span
                                        className={`badge-edge ${
                                            o.payment_status === "paid"
                                                ? "bg-accent-green text-white border-accent-green"
                                                : "bg-paper border-ink"
                                        }`}
                                    >
                                        {o.payment_status}
                                    </span>
                                </td>
                                <td className="p-3 text-right font-mono">{fmtEUR(o.total)}</td>
                            </tr>
                        ))}
                        {orders.length === 0 && (
                            <tr>
                                <td colSpan={5} className="p-8 text-center text-ink/50 font-mono">
                                    Sem encomendas ainda.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
